import clsx from "clsx";
import PropTypes from "prop-types";
import { Modal as SemanticModal } from "semantic-ui-react";
import { Icon } from "hireart-components";
import "./modal-header.scss";

export const ModalHeader = ({
  children,
  className = "",
  closeIcon = false,
  onClose = () => {},
  ...props
}) => (
  <SemanticModal.Header
    {...props}
    className={clsx("ha-modal-header", className)}
  >
    {children}
    {closeIcon && (
      <button className="ha-modal-close-button" type="button" onClick={onClose}>
        <Icon type="close" />
      </button>
    )}
  </SemanticModal.Header>
);

ModalHeader.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  closeIcon: PropTypes.bool,
  onClose: PropTypes.func,
};
